import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { indent, line } from '../slang-printers/prettier-builders.js';
import { printGroupAndIndentIfBreakPair } from '../slang-printers/print-group-and-indent-if-break-pair.js';
import { extractVariant } from '../slang-utils/extract-variant.js';
import { SlangNode } from './SlangNode.js';
import { VariableDeclarationType } from './VariableDeclarationType.js';
import { StorageLocation } from './StorageLocation.js';
import { TerminalNode } from './TerminalNode.js';
import { VariableDeclarationValue } from './VariableDeclarationValue.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class VariableDeclarationStatement extends SlangNode {
  readonly kind = NonterminalKind.VariableDeclarationStatement;

  variableType: VariableDeclarationType['variant'];

  storageLocation?: StorageLocation;

  name: TerminalNode;

  value?: VariableDeclarationValue;

  constructor(
    ast: ast.VariableDeclarationStatement,
    collected: CollectedMetadata
  ) {
    super(ast, collected);

    this.variableType = extractVariant(
      new VariableDeclarationType(ast.variableType, collected)
    );
    if (ast.storageLocation) {
      this.storageLocation = new StorageLocation(
        ast.storageLocation,
        collected
      );
    }
    this.name = new TerminalNode(ast.name, collected);
    if (ast.value) {
      this.value = new VariableDeclarationValue(ast.value, collected);
    }

    this.updateMetadata(this.variableType, this.storageLocation, this.value);
  }

  print(print: PrintFunction): Doc {
    return printGroupAndIndentIfBreakPair(
      [
        print('variableType'),
        this.storageLocation ? indent([line, print('storageLocation')]) : '',
        ' ',
        print('name')
      ],
      [print('value'), ';']
    );
  }
}
